import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';

const SummaryCard = ({ imageSrc, title, value, valueFormatter, cardStyle }) => {
  return (
    <Card style={cardStyle}>
      <CardContent style={{ padding: 14 }}>
        {imageSrc ? (
          <Grid container wrap="nowrap" alignItems="center">
            <Grid item>
              <img src={imageSrc} style={{ maxHeight: 50, width: 'auto' }} alt={title} />
            </Grid>
            <Grid item xs>
              <Typography variant="subtitle2" noWrap>
                {title}
              </Typography>
            </Grid>
          </Grid>
        ) : (
          <Typography variant="subtitle2" noWrap>
            {title}
          </Typography>
        )}
        <Typography
          variant="h5"
          style={{
            marginTop: 8,
            lineHeight: 1.2,
            fontSize: 'clamp(1.05rem, 1.55vw, 1.85rem)',
            letterSpacing: '-0.02em',
            whiteSpace: 'nowrap',
          }}>
          {valueFormatter ? valueFormatter(value) : value}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default SummaryCard;
